import { createStore } from "vuex";

export default createStore({
  state: {
    isLoading: false,  // Estado que maneja si el preloader debe mostrarse
  },
  getters: {},
  mutations: {
    setLoading(state, payload) {
      state.isLoading = payload;  // Mutación para cambiar el estado de isLoading
    },
  },
  actions: {
    startLoading({ commit }) {
      commit('setLoading', true);  // Acción para activar el preloader
    },
    stopLoading({ commit }) {
      commit('setLoading', false);  // Acción para desactivar el preloader
    },
  },
  modules: {},
});
